import { BaseService } from '../../../http/BaseHttpService';
import { NexusMcpServerDto } from '../dtos/responses/NexusMcpServerDto';
import { buildNexusUrl } from '../../../../features/utils/buildNexusUrl';

export class NexusMcpServersService extends BaseService {

    private readonly subscriptionKey = process.env.REACT_APP_NEXUS_APIM_SUBSCRIPTION_KEY ?? '';
    private readonly subKeyHeader = process.env.REACT_APP_NEXUS_APIM_KEY_HEADER_NAME ?? '';

    constructor(private readonly baseUrl: string) {
        super();
    }

    public async getMcpServersAsync(accessToken: string): Promise<NexusMcpServerDto[]> {
        return this.getResponseAsync<NexusMcpServerDto[]>(
            {
                url: buildNexusUrl(this.baseUrl, 'mcp-servers'),
                method: 'GET',
                headers: {
                    [this.subKeyHeader]: this.subscriptionKey,
                },
            },
            accessToken,
        );
    }
}
